import { useTheme } from "@mui/material/styles";
import { tokens } from "../../theme";

const useColors = () => {
  const theme = useTheme();
  return tokens(theme.palette.mode);
};

export default useColors;
